import stationPodcastRouter from "@/routes/stationPodcastRouter"
import stationAutomationRouter from "@/routes/stationAutomationRouter"
import { i18n } from "@/plugins/i18n"

export default [
  {
    path: "stations",
    component: () => import("@/views/Stations/Stations.vue"),
    children: [
      {
        path: "",
        name: "stations",
        component: () => import("@/views/Stations/StationList.vue"),
        meta: {
          pageTitle: i18n.t("route.page_title.account.stations"),
          rule: "owner",
        },
      },
      {
        path: "deleted",
        name: "stations.deleted",
        component: () => import("@/views/Stations/StationDeletedList.vue"),
        meta: {
          pageTitle: i18n.t("route.page_title.account.deleted_stations"),
          parent: "stations",
          rule: "owner",
        },
      },
      {
        path: "create",
        component: () => import("@/views/Stations/StationCreate.vue"),
        name: "station.create",
        props: true,
        meta: {
          pageTitle: i18n.t("route.page_title.account.station.create"),
          parent: "stations",
          rule: "owner",
        },
      },
      {
        path: ":stationKey",
        component: () => import("@/views/Stations/Station.vue"),
        name: "station",
        props: true,
        meta: {
          pageTitle: i18n.t("route.page_title.account.station.home"),
          parent: "stations",
          rule: "owner",
        },
        children: [
          ...stationAutomationRouter,
          ...stationPodcastRouter,
          {
            name: "station.widget",
            path: "widget",
            component: () => import("@/views/Stations/StationWidget.vue"),
            meta: {
              pageTitle: "Station widget",
              parent: "stations",
              rule: "owner",
            },
          },
          {
            name: "station.ctl",
            path: "ctl",
            component: () => import("@/views/Stations/StationCTL.vue"),
            meta: {
              pageTitle: "Call-To-Listen",
              parent: "stations",
              rule: "owner",
            },
          },
          {
            name: "station.settings",
            path: "settings",
            component: () => import("@/views/Stations/StationSettings.vue"),
            meta: {
              pageTitle: "Station settings",
              parent: "stations",
              rule: "owner",
            },
            children: [
              {
                name: "station.stream",
                path: "stream",
                component: () => import("@/views/Stations/Settings/StationSettingsStream.vue"),
                meta: {
                  pageTitle: i18n.t("route.page_title.account.station.settings.stream"),
                  parent: "stations.station.settings",
                  rule: "owner",
                },
              },
              {
                name: "station.info",
                path: "info",
                component: () => import("@/views/Stations/Settings/StationSettingsInfo.vue"),
                meta: {
                  pageTitle: i18n.t("route.page_title.account.station.settings.info"),
                  parent: "stations.station.settings",
                  rule: "owner",
                },
              },
              {
                name: "station.people",
                path: "people",
                redirect: (to) => ({
                  name: "account.people",
                  params: {
                    accountKey: to.params.accountKey,
                  },
                  query: {
                    scopeType: "station",
                    scopeKey: to.params.stationKey,
                  },
                }),
                meta: {
                  pageTitle: i18n.t("route.page_title.account.station.settings.people"),
                  parent: "stations.station.settings",
                  rule: "owner",
                },
              },
              {
                name: "station.ads",
                path: "ads",
                component: () => import("@/views/Stations/Settings/StationAuthorizedDigitalSellers.vue"),
                meta: {
                  pageTitle: "Authorized Digital Sellers",
                  parent: "stations.station.settings",
                  rule: "owner",
                },
              },
              {
                name: "station.sellers-json",
                path: "sellers-json",
                component: () => import("@/views/Stations/Settings/StationSellersJson.vue"),
                meta: {
                  pageTitle: "Sellers.json",
                  parent: "stations.station.settings",
                  rule: "owner",
                },
              },
              {
                name: "station.advertising",
                path: "advertising",
                component: () => import("@/views/Stations/Settings/StationAdvertisingConfig.vue"),
                meta: {
                  pageTitle: "Advertising configuration",
                  parent: "stations.station.settings",
                  rule: "owner",
                },
              },
              {
                name: "station.alerts",
                path: "alerts",
                component: () => import("@/views/Stations/Settings/StationSettingsAlerts.vue"),
                meta: {
                  pageTitle: "Monitoring Alerts",
                  parent: "stations.station.settings",
                  rule: "owner",
                },
              },
            ],
          },
        ],
      },
    ],
  },
]
